<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="560">
    <v-card class="dialog-card" v-if="item">
      <v-card-title class="dialog-title">
        รายละเอียดการติดต่อ
        <v-spacer />
        <v-btn icon @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6">
            <span class="field-label">ชื่อ - นามสกุล</span>
            <div class="field-value">
              {{ item.prefix || "" }}{{ item.firstName }} {{ item.lastName }}
            </div>
          </v-col>

          <v-col cols="12" md="6">
            <span class="field-label">ประเภทการติดต่อ</span>
            <div class="field-value">{{ item.contactType || "-" }}</div>
          </v-col>

          <v-col cols="12" md="6">
            <span class="field-label">อีเมล</span>
            <div class="field-value">{{ item.email }}</div>
          </v-col>

          <v-col cols="12" md="6">
            <span class="field-label">เบอร์โทรศัพท์</span>
            <div class="field-value">{{ item.phone }}</div>
          </v-col>

          <v-col cols="12">
            <span class="field-label">ข้อความ</span>
            <div class="field-value message-box">{{ item.message }}</div>
          </v-col>

          <v-col cols="12" md="6">
            <span class="field-label">วันที่ส่ง</span>
            <div class="field-value">{{ formatDate(item.createdAt) }}</div>
          </v-col>

          <v-col cols="12" md="6">
            <span class="field-label">สถานะ</span>
            <v-select
              v-model="status"
              :items="statusItems"
              outlined
              dense
              hide-details
              :menu-props="{ offsetY: true }"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn text @click="$emit('input', false)">ปิด</v-btn>
        <v-btn
          color="#F4811F"
          dark
          :loading="loading"
          :disabled="status === item.status"
          @click="$emit('save-status', { id: item.id, status })"
        >
          บันทึกสถานะ
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "AdminContactManagementDialog",

  props: {
    value: { type: Boolean, default: false },
    item: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },

  data() {
    return {
      status: "ใหม่",
      statusItems: ["ใหม่", "กำลังดำเนินการ", "เสร็จสิ้น"],
    };
  },

  watch: {
    item(val) {
      this.status = val?.status || "ใหม่";
    },
  },

  methods: {
    formatDate(d) {
      if (!d) return "-";
      const date = new Date(d);
      if (isNaN(date.getTime())) return "-";
      return date.toLocaleString("th-TH", {
        dateStyle: "long",
        timeStyle: "short",
      });
    },
  },
};
</script>

<style scoped>
.dialog-card {
  border-radius: 16px !important;
}
.dialog-title {
  font-size: 18px;
  font-weight: 700;
  color: #1f2a39;
}
.field-label {
  display: block;
  font-size: 13px;
  color: #6b717f;
  margin-bottom: 2px;
}
.field-value {
  font-size: 14px;
  color: #1f2a39;
  margin-bottom: 12px;
  word-break: break-word;
}
.message-box {
  white-space: pre-wrap;
  background: #f9fafc;
  border-radius: 8px;
  padding: 10px 12px;
}
</style>
